import React from "react";

const shapeOf = (l) => {
  const st = String(l?.stack_type || "").replace("_fallback", "").replace("_relaxed", "");
  if (st === "primary_only") return "naked";
  if (st === "primary_secondary") return "qb1";
  if (st === "primary_secondary_tertiary") return "qb2";
  const qb = (l?.players || []).find((p) => p.position === "QB");
  if (!qb) return null;
  const own = (l.players || []).filter((p) => (p.position === "WR" || p.position === "TE") && p.team === qb.team).length;
  return own >= 2 ? "qb2" : own === 1 ? "qb1" : "naked";
};

const flexOf = (l) => {
  const c = { RB: 0, WR: 0, TE: 0 };
  for (const p of l?.players || []) if (c[p.position] != null) c[p.position] += 1;
  return c.RB >= 3 ? "RB" : c.WR >= 4 ? "WR" : c.TE >= 2 ? "TE" : null;
};

const Pill = ({ label, n, total, tid }) => (
  <span className="inline-flex items-center gap-1 border border-zinc-800 bg-black px-2 py-0.5 mono text-[9px] uppercase tracking-widest" data-testid={tid}>
    <span className="text-zinc-500">{label}</span>
    <span className="text-white font-black">{n}</span>
    <span className="text-zinc-600">{total ? Math.round((n / total) * 100) : 0}%</span>
  </span>
);

// Manual results header: how the portfolio actually landed by stack shape and FLEX position.
export const ShapeBreakdown = ({ lineups, showdown = false }) => {
  if (!lineups?.length || showdown) return null;
  const total = lineups.length;
  const s = { naked: 0, qb1: 0, qb2: 0 };
  const f = { RB: 0, WR: 0, TE: 0 };
  for (const l of lineups) {
    const sh = shapeOf(l); if (sh) s[sh] += 1;
    const fx = flexOf(l); if (fx) f[fx] += 1;
  }
  return (
    <div className="flex flex-wrap items-center gap-1.5 mt-1.5" data-testid="raw-shape-breakdown">
      <span className="mono text-[9px] uppercase tracking-widest text-zinc-600 mr-0.5">Shapes</span>
      <Pill label="Naked" n={s.naked} total={total} tid="raw-shape-naked" />
      <Pill label="QB+1" n={s.qb1} total={total} tid="raw-shape-qb1" />
      <Pill label="QB+2" n={s.qb2} total={total} tid="raw-shape-qb2" />
      <span className="mono text-[9px] uppercase tracking-widest text-zinc-600 ml-2 mr-0.5">Flex</span>
      <Pill label="RB" n={f.RB} total={total} tid="raw-flex-RB" />
      <Pill label="WR" n={f.WR} total={total} tid="raw-flex-WR" />
      <Pill label="TE" n={f.TE} total={total} tid="raw-flex-TE" />
    </div>
  );
};

export default ShapeBreakdown;
